import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import Header from "../component/header.component"
import SideNav from "../component/side-nav.component"
import Sidebar from "../component/side-nav.component"
import { useTranslation } from "react-i18next"

export default function Dashboard() {
  const [collapse, setCollapse] = useState<boolean>(false)
  const [loading, setLoading] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])
  return (
    <div className="flex h-screen bg-gray-900 text-gray-100 overflow-hidden">
      <div className="fixed inset-0 z-o">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800" />
        <div className="absolute inset-0 backdrop-blur-sm" />
      </div>

      <Sidebar />

      <div className="flex-1 overflow-auto relative z-10">
        <Header
         title={t("projectTitle")} 
        //  title={t("projectTitle")} 
         />
        {!loading && <Outlet />}
      </div>
    </div>
  )
}
